import React, { useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { blackUser } from "@/assets";
import { Card } from "@/components/ui/card";

export default function CallingUnknown() {
  const [expanded, setExpanded] = useState(false);

  const orders = [
    { id: "T587k8", table: "A2", guest: 6, date: "20 July 2025" },
    { id: "2587k8", table: "A2", guest: 6, date: "20 July 2025" },
    { id: "2587k8", table: "A2", guest: 6, date: "20 July 2025" },
  ];

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
      <Card
        className={` text-cwhite2 transition-all duration-300 overflow-hidden ${
          expanded ? "w-[900px] h-[480px]" : "w-[400px] h-[420px]"
        }`}
      >
        {/* Header */}
        <div className="relative flex justify-center items-center p-4  ">
          <button
            onClick={() => setExpanded(!expanded)}
            className="absolute top-3 right-3 p-2 text-gray-400 hover:text-white"
          >
            {expanded ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
          </button>
        </div>

        <div className="flex h-full">
          {/* Left Section */}
          <div
            className={`flex flex-col items-center justify-center flex-1 p-4 ${
              expanded ? "border-r border-cblack7 " : ""
            }`}
          >
            <img
              src={blackUser}
              alt="avatar"
              className="w-24 h-24 rounded-full mb-3"
            />
            <p className="text-lg font-medium">
              {expanded ? "Md Rasel" : "Unknown"}
            </p>
            <p className="text-sm text-cwhite3">+98653246312</p>
            <p className="text-xs text-cwhite3 mt-1">21/02/2025 12:00 AM</p>

            <div className="flex flex-col gap-3 w-full mt-6">
              <Button className="bg-cblue text-white w-full">
                Reservation
              </Button>
              <div className="flex gap-3">
                <Button className="bg-cgreen text-white flex-1">
                  Take Order
                </Button>
                <Button variant="destructive" className="flex-1">
                  Close
                </Button>
              </div>
            </div>
          </div>

          {/* Right Section (Visible only when expanded) */}
          {expanded && (
            <div className="flex-1 p-4 overflow-y-auto space-y-3">
              {orders?.map((order, idx) => (
                <div
                  key={idx}
                  className="bg-cblack6 rounded-md p-4 flex items-center justify-between"
                >
                  <div className="space-y-1 text-sm">
                    <p className="text-cyellow">
                      <span className="text-gray-400">Order ID:</span>{" "}
                      {order.id}
                    </p>
                    <p className="text-cwhite3">
                      <span className="">Table:</span> {order.table}
                    </p>
                    <p className="text-cwhite3">
                      <span className="">Guest:</span> {order.guest}
                    </p>
                    <p className="text-cwhite3">
                      <span className="">Date:</span> {order.date}
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <Button className="bg-cblue text-white text-sm">
                      View Details
                    </Button>
                    <Button className="bg-cgreen text-sm text-white">
                      Same as another order
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
